import classnames from 'classnames'
import {memo} from 'react'
import type {ReactNode} from 'react'

import {useOneLine} from '../../../../../contexts/oneLine'
import type {KeyValue} from '../../../../../utils/object'
import styles from '../Build.css'

type Props = {
  className?: string
  hideBorders?: boolean
  alwaysShowLineBorders?: boolean
  children?: ReactNode
  style?: KeyValue<string, string | number>
  inQueue?: boolean
}

function BuildLayout({
  hideBorders = false,
  className,
  alwaysShowLineBorders = false,
  children,
  style,
  inQueue,
}: Props) {
  const oneLine = useOneLine()
  const classes = classnames(styles.build, className, {
    [styles.oneLine]: oneLine === true,
    [styles.oneLinePaddings]: oneLine === true && !inQueue,
    [styles.dottedBorders]: alwaysShowLineBorders && oneLine === true,
    [styles.hideBorders]: hideBorders || (oneLine === true && !alwaysShowLineBorders),
  })
  return oneLine == null ? null : (
    <div className={classes} style={style}>
      {children}
    </div>
  )
}

export default memo(BuildLayout)
